import React from 'react';
import { createView, view, tokens } from '@sail/ui';
export const Check = createView((props)=>{
    return /*#__PURE__*/ React.createElement(view.svg, {
        ...props,
        width: "16",
        height: "8",
        viewBox: "0 0 8 7"
    }, /*#__PURE__*/ React.createElement(view.path, {
        d: "M7.16.18L2.4 4.79 1.13 3.43a.7.7 0 0 0-.87-.04.61.61 0 0 0-.18.8l1.5 2.45c.15.22.41.36.69.36.28 0 .53-.14.68-.36C3.2 6.33 7.77.86 7.77.86c.6-.6-.13-1.15-.6-.68z",
        css: {
            fill: tokens.color.icon.onForm.accent
        }
    }));
});
export const CheckIcon = {
    category: 'icon',
    colorable: false,
    name: 'check',
    svg: Check
};

//# sourceMappingURL=check.js.map